module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-ipad-retina-152x152-28abbbcd1221096334e26a6b40c877b4.png";